import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCompletedGroups, tableProps } from '../../../reducers/groups/actions';
import { withRouter, useLocation } from 'react-router-dom';
import Table from '../../../components/simple/Table';
import moment from 'moment';
import { fakeSort } from '../../../utils/table';
import IconButton from '../../../components/simple/IconButton/IconButton';
import { CalendarOutlined, ArrowRightOutlined, FileFilled } from '@ant-design/icons';
import ImagePreview from '../../../components/simple/ImagePreview';

import './CompletedGroupList.scss';
import { Tooltip } from 'antd';
import ModalController from 'controllers/ModalController';
import ModalClosable from 'components/custom/ModalClosable';
import EditScheduleModal from 'components/custom/EditScheduleModal';

function CompletedGroupList(props) {
  
  let { searchQuery, clientId, groupsReducer } = props;
  const location = useLocation();

  const { completedGroups, orderBy, page } = groupsReducer;

  const update = (p) => props.getCompletedGroups(clientId, p || page.completedGroups, orderBy.completedGroups, searchQuery);

  useEffect(_ => update(), [ ]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(_ => update(), [ searchQuery ]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderDetail = (id, class_id) => {
    return (
      <div className='CompletedGroupList__detail'>
        <Tooltip title={ class_id ? 'Ver detalle' : 'No hay clases asignadas a este grupo' }>
          <IconButton
            onClick={() => {
              if (class_id) {
                props.history.push(`/group/${id}/class/${class_id}`, { from: location.pathname });
              }
            }}
            className={`secondary ${ !class_id && 'disabled' }`}
            icon={ <ArrowRightOutlined /> }
          />
        </Tooltip>
        <ModalController
            trigger={({onToggleModal}) => (              
              <Tooltip title='Editar agenda'>
                <IconButton
                  onClick={onToggleModal}
                  className='secondary'
                  icon={ <CalendarOutlined /> }
                />
              </Tooltip>
            )}
            modal={({isModalOpen, onToggleModal}) => {
              const handleCloseEditScheduleModal = () => {
                onToggleModal();
                update();
              }

              return (
                <ModalClosable
                  visible={isModalOpen} 
                  placement="left"
                  children={ 
                    <EditScheduleModal
                      { ...props }
                      groupId={id}
                      clientId={clientId}
                      fetchGroupStudyPlan={() => {}}
                      onClose={handleCloseEditScheduleModal} 
                    /> 
                  }
                />
              )
            }}
          />
      </div>
    )
  }

  const columns = [
    {
      title: 'Nombre grupo',
      dataIndex: 'name',
      ...fakeSort
    },
    {
      title: 'Fecha de inicio',
      dataIndex: 'initial_date',
      render: date => date ? moment(date).format('DD/MM/YYYY') : 'No especificado',
      ...fakeSort
    },
    {
      title: 'Curso',
      dataIndex: 'course'
    },
    {
      title: 'Nivel',
      dataIndex: 'level'
    },
    {
      title: 'Profesor',
      dataIndex: 'teacher'
    },
    {
      title: 'Evidencias',
      dataIndex: 'evidences',
      key: 'evidences',
      render: data => (
        (data || []).length ? 
        <ImagePreview 
          data={data}
          isIcon={true} 
          component={FileFilled} 
        /> : null
      ),
    },
    {
      align: 'right',
      title: '',
      dataIndex: 'detail',
      render: (detail, { id, class_id }) => renderDetail(id, class_id)
    }
  ];
  
  return (
    <div className='CompletedGroupList'>
      { props.children }
      <Table
        { ...props }
        onChange={(pager, filter, sort) => 
          props.tableProps(pager.current, sort, 'completedGroups').then(() => {
            update(pager.current)
          })
        }
        loading={ !!groupsReducer.loading.GET_COMPLETED_GROUPS?.state }
        columns={ columns }
        data={ completedGroups }
      />
    </div>
  );
}

export default withRouter(connect((state) => ({
  groupsReducer: state.get('groupsReducer')
}), (dispatch) => {
  return bindActionCreators({ getCompletedGroups, tableProps }, dispatch);
})(CompletedGroupList));